
export const tableHeight = () => {
    return (window.innerHeight - 250);
}
